// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_hf-0";
export var actionModalContentContainer = "_hf-1";
export var createTagButton = "_hf-2";
export var footerContainer = "_hf-7";
export var fullWidthDivider = "_hf-3";
export var hasCreateTagButton = "_hf-4";
export var noCreateTagButton = "_hf-5";
export var tagsContainer = "_hf-6";
export var tagsModalContentContainer = "_hf-8";